import { type FC, type PropsWithChildren, useContext } from 'react'

import { LoginRegistrationOneTimePasswordRequestForm } from '../../../login-registration/components/LoginRegistrationOneTimePasswordRequestForm/LoginRegistrationOneTimePasswordRequestForm'
import { LoginRegistrationUserLoginForm } from '../../../login-registration/components/LoginRegistrationUserLoginForm/LoginRegistrationUserLoginForm'
import {
  LOGIN_OTP_STATE,
  LoginRegistrationUserLoginStateContext,
} from '../../../login-registration/context/LoginRegistrationUserLoginStateContext'
import { type LoginAfterLoggedIn } from '../../../login-registration/loginAfterLoggedIn'

import { LoginRegistrationUserLoginFormEmailInput } from './LoginRegistrationUserLoginFormEmailInput'
import { LoginRegistrationUserOneTimePasswordInputForm } from './LoginRegistrationUserOneTimePasswordInputForm'
import { LoginRegistrationUserPasswordLoginForm } from './LoginRegistrationUserPasswordLoginForm'

interface LoginRegistrationLoginRenderSwitchExperimentProps {
  afterLoggedIn?: LoginAfterLoggedIn
}

export const LoginRegistrationLoginRenderSwitchExperiment: FC<
  PropsWithChildren<LoginRegistrationLoginRenderSwitchExperimentProps>
> = ({ afterLoggedIn, children }) => {
  const { loginOtpState } = useContext(LoginRegistrationUserLoginStateContext)

  switch (loginOtpState) {
    case LOGIN_OTP_STATE.LOGIN_REGISTER: {
      return (
        <LoginRegistrationUserLoginFormEmailInput>
          {children}
        </LoginRegistrationUserLoginFormEmailInput>
      )
    }
    case LOGIN_OTP_STATE.OTP_INPUT: {
      return (
        <LoginRegistrationUserOneTimePasswordInputForm
          afterLoggedIn={afterLoggedIn}
        />
      )
    }
    case LOGIN_OTP_STATE.OTP_REQUEST: {
      return <LoginRegistrationOneTimePasswordRequestForm />
    }
    case LOGIN_OTP_STATE.OTP_REQUEST_NEW_CODE: {
      return <LoginRegistrationOneTimePasswordRequestForm isReRequest />
    }
    case LOGIN_OTP_STATE.PASSWORD_INPUT: {
      return (
        <LoginRegistrationUserPasswordLoginForm afterLoggedIn={afterLoggedIn}>
          {children}
        </LoginRegistrationUserPasswordLoginForm>
      )
    }
    default: {
      return <LoginRegistrationUserLoginForm />
    }
  }
}
